// Partner portal feature flags

const normalizeBoolean = (value: unknown): boolean => {
  if (typeof value === 'boolean') {
    return value
  }
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true'
  }
  return false
}

const MARKETPLACE_ENV = process.env.REACT_APP_MARKETPLACE_ENABLED ?? 'true'
const SECURITY_FEATURE_ENV = process.env.REACT_APP_SECURITY_FEATURE_ENABLED ?? 'false'

export const MARKETPLACE_ENABLED = normalizeBoolean(MARKETPLACE_ENV)
export const SECURITY_FEATURE_ENABLED = normalizeBoolean(SECURITY_FEATURE_ENV)
